import styled from 'styled-components';

export const ChartWrapper = styled.div`
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const LegendDot = styled.div<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
`;

export const LegendLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;
